import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";
import useGoogleAnalytics from "./useGoogleAnalytics";

const useGoogleAnalyticsPageview = () => {
  const location = useLocation();
  const initialized = useGoogleAnalytics();
  const [previousPageview, setPreviousPageview] = useState<string>();

  useEffect(() => {
    const url = location.pathname + location.search;

    if (initialized && url !== previousPageview) {
      setPreviousPageview(url);
      ReactGA.pageview(url);
    }
  }, [location.pathname, location.search, previousPageview, initialized, location]);
};

export default useGoogleAnalyticsPageview;
